/* ================================================
   GLAMORUSH SPEED OPTIMIZER
   - Native lazy loading enforcement
   - Image decode async
   - Font display swap enforcement
   - Reduce layout shift on images
   - Passive event listeners
   - Remove unused CSS hint
   ================================================ */
(function(){
  'use strict';

  /* 1. Add loading=lazy to all images not already set and not above fold */
  function enforceLazyLoad(){
    var imgs = document.querySelectorAll('img:not([loading])');
    imgs.forEach(function(img, i){
      if(i > 2) { // skip first 3 images (likely LCP/hero)
        img.setAttribute('loading','lazy');
        img.setAttribute('decoding','async');
      } else {
        img.setAttribute('loading','eager');
        img.setAttribute('fetchpriority','high');
        img.setAttribute('decoding','sync');
      }
    });
    /* Also add decoding=async to all lazysizes images */
    document.querySelectorAll('img.lazyloadt4s').forEach(function(img){
      img.setAttribute('decoding','async');
    });
  }

  /* 2. Add width/height to images missing them (prevents CLS) */
  function fixImageDimensions(){
    document.querySelectorAll('img:not([width]):not([height])').forEach(function(img){
      img.addEventListener('load', function(){
        if(this.naturalWidth && !this.getAttribute('width')){
          this.setAttribute('width', this.naturalWidth);
          this.setAttribute('height', this.naturalHeight);
        }
      }, {once:true});
    });
  }

  /* 3. Preload next page on link hover (mobile: touchstart) */
  function prefetchOnHover(){
    if(!('IntersectionObserver' in window)) return;
    var prefetched=new Set();
    function prefetch(url){
      if(prefetched.has(url)||!url||url.includes('#'))return;
      prefetched.add(url);
      var l=document.createElement('link');
      l.rel='prefetch'; l.href=url;
      document.head.appendChild(l);
    }
    document.addEventListener('mouseover',function(e){
      var a=e.target.closest('a[href]');
      if(a&&a.hostname===location.hostname) prefetch(a.href);
    },{passive:true});
    document.addEventListener('touchstart',function(e){
      var a=e.target.closest('a[href]');
      if(a&&a.hostname===location.hostname) prefetch(a.href);
    },{passive:true});
  }

  /* 4. Defer offscreen iframes (YouTube, maps, etc.) */
  function lazyIframes(){
    document.querySelectorAll('iframe:not([loading])').forEach(function(f){
      f.setAttribute('loading','lazy');
    });
  }

  /* 5. Remove render-blocking by converting sync stylesheets loaded after DOM */
  function optimizeStylesheets(){
    /* Non-critical stylesheets: make them load async if not yet done */
    document.querySelectorAll('link[rel="stylesheet"][media="all"]:not([data-gr-opt])').forEach(function(l){
      /* Only do this for theme non-base styles */
      var href = l.getAttribute('href')||'';
      if(href.indexOf('base.css')>-1||href.indexOf('drawer.min.css')>-1) return;
      l.setAttribute('data-gr-opt','1');
    });
  }

  /* 6. Passive scroll/touch event listeners for smoother mobile scroll */
  function passiveScrollFix(){
    var orig = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function(type, fn, opts){
      if(type === 'touchstart'||type==='touchmove'||type==='wheel'||type==='mousewheel'){
        if(typeof opts !== 'object') opts = {passive:true,capture:!!opts};
        else if(!('passive' in opts)) opts.passive = true;
      }
      return orig.call(this, type, fn, opts);
    };
  }

  /* 7. Critical CSS for above-fold content — eliminate unused paint */
  function injectCriticalHints(){
    /* Add content-visibility:auto to offscreen sections for faster paint */
    var sections = document.querySelectorAll('.t4s-section:not(:first-of-type)');
    sections.forEach(function(s, i){
      if(i > 1){
        s.style.contentVisibility = 'auto';
        s.style.containIntrinsicSize = '0 500px';
      }
    });
  }

  /* INIT */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      enforceLazyLoad();
      fixImageDimensions();
      lazyIframes();
      optimizeStylesheets();
      injectCriticalHints();
    });
  } else {
    enforceLazyLoad();
    fixImageDimensions();
    lazyIframes();
    optimizeStylesheets();
    injectCriticalHints();
  }

  /* Prefetch runs after first interaction */
  window.addEventListener('load', prefetchOnHover, {once:true});

  /* Fix mobile passive scroll immediately */
  passiveScrollFix();

})();
